module.exports = __webpack_public_path__ + "img/Avatar-25.e95cfabe.svg";